module.exports = __webpack_public_path__ + "ae6bd50272709c9c836bc82b228f19c6.pdf";